import { APIGet, APIPost, APIPut, APIDelete } from "api/protocols";
import { TTeesheetCustomerTypeConfig } from "redux/reducers/models/facility";
import { IBookingCategory } from "redux/reducers/models/teetime";

const apiVersion = "2022-09";
const adminType = "facility-admin";
const baseCustomerUrl = "/" + apiVersion + "/" + adminType + "/customer/type";

interface ICustomerType {
  id?: number;
  title?: string;
  // migrate_customer_type_id?: number;
  subtitle?: string | null;
  configuration?: TTeesheetCustomerTypeConfig;
  booking_category_id?: number;
  booking_category?: IBookingCategory;
  days_in_advance_start?: number | null;
  days_in_advance_end?: number | null;
  open_time?: string | null;
}

interface ICustomerTypeRes {
  status: number;
  data: any;
}

interface IGetCustomerType {
  id?: number;
  application?: string;
  configuration?: boolean;
}

// Get customer types
export async function GetCustomerType(params: IGetCustomerType, useGlobalLoader?: boolean): Promise<ICustomerTypeRes> {
  return await APIGet(baseCustomerUrl, params, useGlobalLoader);
}

//Post new customer type
export async function PostCustomerType(params: ICustomerType, useGlobalLoader?: boolean): Promise<ICustomerTypeRes> {
  return await APIPost(baseCustomerUrl, params, useGlobalLoader);
}

//Edit existing customer type
export async function PutCustomerType(params: ICustomerType, useGlobalLoader?: boolean): Promise<ICustomerTypeRes> {
  return await APIPut(baseCustomerUrl, params, useGlobalLoader);
}

//Delete and migrate customer type
export async function DeleteCustomerType(params: ICustomerType, useGlobalLoader?: boolean): Promise<ICustomerTypeRes> {
  return await APIDelete(baseCustomerUrl, params, useGlobalLoader);
}

export async function PutCustomerTypeConfiguration(
  params: { configurations: TTeesheetCustomerTypeConfig[] },
  useGlobalLoader?: boolean,
): Promise<ICustomerTypeRes> {
  return await APIPut(baseCustomerUrl.concat("/configuration"), params, useGlobalLoader);
}
